module.exports = __webpack_public_path__ + "static/img/18.ccd76d8d.jpg";